export default function removeSpecialCharacters(inputString) {
  // Define a regular expression pattern to match special characters
  const pattern = /[^a-zA-Z0-9 ]/g;

  // Use the replace method with the pattern to replace special characters with an empty string
  const cleanedString = inputString.replace(pattern, '');

  return cleanedString;
}
